/* eslint-disable @typescript-eslint/no-explicit-any -- existing annotations; retyping would change compile behavior */
import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { SvgIcon, IconButton } from '@mui/material';
import { MdOutlineArrowBackIosNew } from 'react-icons/md';

import { RootState } from '../../../../redux/store';
// import { updateEmployee } from 'redux/usersPermissions';
import { newEmployee } from 'views/ProviderProfile/types';
// import PersonForm from '../PersonForm/PersonForm';

import styles from './EditPage.module.scss';
import api from 'api';
import { Controller, useForm } from 'react-hook-form';
import BaseInput from 'components/common/BaseInput';
import HelperDesc from 'components/common/WarningInputMessage/WarningInputMessage';
import Autocomplete from '@mui/material/Autocomplete';
import PrimaryButton from 'components/common/PrimaryButton/PrimaryButton';

import AlertMessage, { AlertObj } from 'components/common/alert';
import { PERMISSIONS_TO_ASSIGN_USER_ROLES, Role } from 'data/constants/roles';

const EditPage = () => {
    const [user, setUser] = useState<any>();
    const [userForm, setUserForm] = useState<any>();

    const params = useParams();
    const navigate = useNavigate();

    const [isShowingAlert, setShowingAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState<AlertObj>({ type: 'info', value: '' });

    const user_admin = useSelector((state: RootState) => state.user.entity);

    const roleOptions = PERMISSIONS_TO_ASSIGN_USER_ROLES[user_admin.role as Role];

    const { control, reset, handleSubmit } = useForm<any>({
        mode: 'all',
        defaultValues: {
            role: '',
        },
    });

    // useEffect(() => {
    //     const targetUser = users.find((user) => user.id === params.id);
    //     if (targetUser) {
    //         setUser(targetUser);
    //     }
    // }, [users]);

    useEffect(() => {
        fetchConsultant();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    async function fetchConsultant() {
        if (params.id) {
            const response = await api.immigrationProfessional.get(params.id);

            if (response.status === 200 && response.status) {
                setUser(response.data);
            }
        }
    }

    const goBack = () => {
        navigate(-1);
    };

    const submitForm = async (data: newEmployee) => {
        const updateUser: any = {
            role: data.role,
        };
        try {
            const resUser = await api.immigrationProfessional.put(params.id, updateUser);
            if (resUser.status === 200 || resUser.status === 201) {
                setAlertMessage({ type: 'success', value: 'Role successfully added!' });
                setShowingAlert(true);
            }
        } catch {
            setAlertMessage({ type: 'error', value: 'Something went wrong.' });
            setShowingAlert(true);
        }
        // dispatch(updateEmployee(updateUser));
        setTimeout(() => {
            navigate('/account/permissions');
        }, 2000);
    };

    useEffect(() => {
        if (user) {
            setUserForm({
                role: user.role,
            });
        }
    }, [user]);

    useEffect(() => {
        if (userForm) {
            reset(userForm);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userForm]);

    const Alert = (
        <AlertMessage
            type={alertMessage?.type}
            text={alertMessage?.value}
            open={isShowingAlert}
            onClose={() => setShowingAlert(false)}
        ></AlertMessage>
    );

    return (
        <div className={styles.root}>
            {Alert}
            <IconButton
                onClick={() => goBack()}
                style={{
                    fontFamily: 'Assistant, sans-serif',
                    fontSize: '15px',
                    color: '#282828',
                    height: '36px',
                    width: '36px',
                    borderRadius: '50%',
                    boxSizing: 'border-box',
                }}
            >
                <SvgIcon
                    style={{ width: '9px', height: '15px' }}
                    viewBox="7 3 12 19"
                    component={MdOutlineArrowBackIosNew}
                />
            </IconButton>
            {userForm && (
                <form autoComplete="off" onSubmit={handleSubmit(submitForm)}>
                    <h1 className={styles.title}>Edit user</h1>
                    <div className={styles.form}>
                        <Controller
                            name={'role'}
                            control={control}
                            rules={{ required: 'Required field' }}
                            render={({
                                field: { onChange, onBlur, value },
                                fieldState: { error },
                            }) => (
                                <Autocomplete
                                    id={'role'}
                                    options={roleOptions}
                                    getOptionLabel={(option) => option}
                                    renderInput={(params) => (
                                        <BaseInput
                                            {...params}
                                            label="*Role"
                                            onBlur={onBlur}
                                            error={error ? true : false}
                                            helperText={
                                                error ? (
                                                    <HelperDesc
                                                        message={error.message?.toString()}
                                                    />
                                                ) : (
                                                    ''
                                                )
                                            }
                                        />
                                    )}
                                    value={value}
                                    onChange={(_, data) => {
                                        onChange(data);
                                        return data;
                                    }}
                                />
                            )}
                        />
                    </div>
                    {/* {user && (
                <PersonForm
                    btnName="Apply changes"
                    initialFormValue={user}
                    getFormData={submitForm}
                />
            )} */}

                    <PrimaryButton variant="outlined" size="min" color="blue">
                        <span className={styles.btn}>Save Changes</span>
                    </PrimaryButton>
                </form>
            )}
        </div>
    );
};

export default EditPage;
